import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../core/helpers/default';

const name = 'donationsList';

const reducersKeys = {
  getDonationsRequest: 'getDonationsRequest',
  getDonationsSuccess: 'getDonationsSuccess',
  getDonationsFailure: 'getDonationsFailure',
};

const initialState = {
  donations: [],
  meta: {
    page: 1,
    lastPage: 1,
    perPage: 10,
  },
  loaded: false,
  loading: false,
  error: null,
};

const donationsList = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.getDonationsRequest]: (state) => {
      state.loading = true;
      state.loaded = false;
    },
    [reducersKeys.getDonationsSuccess]: (state, { payload }) => {
      state.donations = payload.donations;
      state.meta = { ...payload.meta };
      state.loading = false;
      state.loaded = true;
    },
    [reducersKeys.getDonationsFailure]: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
  },
});

export const donationsListReducers = createReducerNames(name, reducersKeys);
export const { actions } = donationsList;

export default donationsList.reducer;
